import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.app;

export const appSelectors = {
    isLoading: createSelector(selector, (state) => state.isLoading),
    showModal: createSelector(selector, (state) => state.showModal),
    modalObject: createSelector(selector, (state) => state.modalObject),
    showSessionExpiredModal: createSelector(selector, (state) => state.showSessionExpiredModal),
}